import React from 'react';

import { ReactComponent as Illustration } from 'svg/home.svg';

import './style.css';

const Hero = () => {
  return (
    <section className="hero">
      <h1 className="hero-message">
        A slight
        <br />
        adjustment
        <br />
        for <b>growth</b>
      </h1>
      <Illustration className="hero-illustration" />
    </section>
  );
};

export default Hero;
